import { render } from "./TariffsTable.vue?vue&type=template&id=e25a3350"
import script from "./TariffsTable.vue?vue&type=script&lang=js"
export * from "./TariffsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__